import { Injectable } from '@angular/core';
import {Dict, PathPoint, PlacedUserObjects} from '../interfaces/common.interfaces';
import {map, Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {EnvProviderService} from './env-provider.service';
import {TranslocoService} from '@ngneat/transloco';

export interface HistoryItem {
  session?: string;
  type: 'quest' | 'obelisk' | 'tracking';
  label: string;
  timestamp: Date;
  saved: boolean;
  state?: {
    path?: PathPoint[];
    time?: number;
    calories?: number;
    distance?: number;
    steps?: number;
    purityOfCompletion?: {
      value: number;
      data?: Dict<any>
    };
  };
  body?: Dict<any>;
}

export interface QuestHistoryItem {
  session?: string;
  questId: number;
  questName: string;
  status: 'completed' | 'failed';
  saved: boolean;
  mine: boolean;
  player?: {
    id: number;
    username: string;
    firstName: string;
    lastName: string;
    level: number;
    paragon: number;
  }
  state: {
    path?: PathPoint[];
    time?: number;
    calories?: number;
    distance?: number;
    steps?: number;
    userPlacedObjects?: PlacedUserObjects
  };
  data?: any;
  timestamp: Date;
}


@Injectable({
  providedIn: 'root'
})
export class QuestsHistoryService {

  private readonly ROOT_URL = `/quests/`;

  constructor(private http: HttpClient, private env: EnvProviderService, private transloco: TranslocoService) { }

  getQuestHistoryItem$(sessionId: string): Observable<QuestHistoryItem> {
    return this.http.get(`${this.env.environment.API_URL}${this.ROOT_URL}progress/history/${sessionId}`).pipe(map((value: any) => this.transformFromServer(value)));
  }

  updateQuestHistoryItem$(item: QuestHistoryItem): Observable<void> {
    item = {...item};
    delete item['status'];
    return this.http.patch(`${this.env.environment.API_URL}${this.ROOT_URL}progress/${item.session}`, item).pipe(map(() => void 0));
  }

  private transformFromServer(raw: any): QuestHistoryItem {
    return {
      session: raw.session,
      questId: raw.quest_id,
      questName: raw.quest_name && raw.quest_name.toLowerCase().includes('daily') ? this.transloco.translate(raw.quest_name) : raw.quest_name,
      status: raw.status === 'c' ? 'completed' : 'failed',
      state: raw.state,
      saved: true,
      mine: raw.mine,
      player: raw.player ? {
        id: raw.player.id,
        username: raw.player.username,
        firstName: raw.player.first_name,
        lastName: raw.player.last_name,
        level: raw.player.level,
        paragon: raw.player.paragon
      } : null,
      timestamp: new Date(raw.updated_at)
    }
  }
}
